import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Menu } from '@headlessui/react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { logoutUser } from '../../../auth/Actions';
import { UserCircleIcon } from '@heroicons/react/24/solid';

const UserMenu = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const permissions = useSelector((state) => state.auth.permissions);
  const buttonRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({ bottom: 9999, left: 0 });

  const navigation = [
    { name: 'Home', href: '/' },
    {
      name: 'Admin Dashboard',
      href: '/admin',
      permission: 'view_admin_dashboard'  // You can adjust this permission name as needed
    }
  ];

  // Calculate menu position when button is clicked
  const updateMenuPosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      // Position menu so its bottom edge is just above the button's top
      // bottom CSS = distance from viewport bottom to element's bottom edge
      const distanceFromViewportBottom = window.innerHeight - rect.top + 8;
      setMenuPosition({
        bottom: distanceFromViewportBottom,
        left: rect.left
      });
    }
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button
        ref={buttonRef}
        onClick={updateMenuPosition}
        className="flex items-center"
      >
        <UserCircleIcon className="text-ink w-8 h-8 cursor-pointer hover:opacity-80" />
      </Menu.Button>

      {createPortal(
        <Menu.Items
          className="fixed w-64 rounded-lg shadow-lg bg-surface divide-y divide-line ring-1 ring-line  z-[10000]"
          style={{ bottom: menuPosition.bottom, left: menuPosition.left }}
        >
          <div className="px-4 py-3">
            <p className="text-lg font-semibold text-ink">
              {user?.first_name} {user?.last_name}
            </p>
            <p className="text-sm text-ink-muted">{user?.email}</p>
          </div>
          
          <div className="py-1">
            {navigation.map((item, index) => {
              if (item.permission && !permissions?.includes(item.permission)) {
                return null;
              }
              return (
                <Menu.Item key={index}>
                  {({ active }) => (
                    <NavLink
                      to={item.href}
                      className={`block px-4 py-2 text-ink cursor-pointer ${
                        active ? 'bg-surface-raised' : ''
                      }`}
                    >
                      {item.name}
                    </NavLink>
                  )}
                </Menu.Item>
              );
            })}


          </div>

          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`w-full text-left px-4 py-2 text-danger cursor-pointer ${
                    active ? 'bg-surface-raised' : ''
                  }`}
                  onClick={() => dispatch(logoutUser())}
                >
                  Logout
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>,
        document.body
      )}

    </Menu>
  );
};

export default UserMenu; 